import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Divider, Typography, CardMedia, DialogTitle } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import Tour from 'reactour';
import WelcomeMessage from 'src/components/WelcomeMessage';
import { getTourOpen, getUser, setTourOpen } from 'src/utils/Common';
import { styled } from '@mui/system';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'src/utils/axios';
import Confetti from 'react-confetti';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  posts: {
    marginTop: theme.spacing(2)
  },
  post: {
    marginBottom: theme.spacing(2)
  },
  icon: {
    align: 'center',
    textAlign: 'center'
  },
}));

const StyledCardMedia = styled(CardMedia)({
  height: '100%',
  width: '100%',
  backgroundSize: 'contain',
});

function Timeline({ className, ...rest }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const [openPerakendeTV, setopenPerakendeTV] = React.useState(false);
  const [avatarEmployee, setAvatarEmployee] = React.useState(null);

  const [tour, setTour] = React.useState(getTourOpen());
  const [openBirthday, setopenBirthday] = React.useState(false);

  const [openBirthDayMessage, setOpenBirthDayMessage] = React.useState(false);
  const [birthDayMessage, setBirthDayMessage] = React.useState('');

  const [openWorkAnniversary, setopenWorkAnniversary] = React.useState(false);
  const [workAnniversaryMessage, setWorkAnniversaryMessage] = React.useState('');

  const [celebrationType, setCelebrationType] = React.useState(0);
  const [celebrationMessage, setCelebrationMessage] = React.useState('');
  const [openCelebrationMessage, setOpenCelebrationMessage] = React.useState(false);

  const steps = [
    {
      content: <Typography variant="h6" gutterBottom>
        Apollo Uygulamasına Hoşgeldiniz. Yönergeleri Takip Ediniz!...
      </Typography>,
    },
    {
      selector: '[data-tour="OpenNavbarButton"]',
      content: <Typography variant="h6" gutterBottom>
        Menüyü Buradan Açabilirsiniz
      </Typography>,
      position: 'left',
    },
    {
      selector: '[data-tour="LogoutButton"]',
      content: <Typography variant="h6" gutterBottom>
        Buradan Çıkış Yapabilirsiniz
      </Typography>,
      position: 'left',
    },
  ]

  const handleCloseBirthday = () => {
    setopenBirthday(false);
    SetApolloEmployeeNotification(1);
  };


  React.useEffect(() => {

    if (parseInt(SessionUser.HappyBirthday) === 1) {
      setTimeout(() => {
        // setopenBirthday(true);
      }, 2000);
    }

    //Bayiler için özel doğum günü mesajı
    if (parseInt(SessionUser.BirthDayNotification) === 1 && SessionUser.BirthDayNotificationMessage) {
      const message = SessionUser.BirthDayNotificationMessage.replace("@CalisanAdSoyad", SessionUser.NameSurname);
      setBirthDayMessage(message);
      setOpenBirthDayMessage(true);
    }

    //Bayiler için özel yıl dönümü mesajı
    if (parseInt(SessionUser.WorkAnniversaryNotification) === 2 && SessionUser.WorkAnniversaryNotificationMessage) {
      const message = SessionUser.WorkAnniversaryNotificationMessage.replace("@CalisanAdSoyad", SessionUser.NameSurname);
      setWorkAnniversaryMessage(message);
      setopenWorkAnniversary(true);
    }

    //BAyiler için özel kutlama mesajı
    if (parseInt(SessionUser.CelebrationNotification) > 2 && SessionUser.CelebrationNotificationMessage) {
      const message = SessionUser.CelebrationNotificationMessage.replace("@CalisanAdSoyad", SessionUser.NameSurname);
      setCelebrationMessage(message);
      setCelebrationType(parseInt(SessionUser.CelebrationNotification));
      setOpenCelebrationMessage(true);
    }


    axios.get('/GetBanner')
      .then((response) => {
        const res = response.data;
        if (res.length === 0) {
          setopenPerakendeTV(false);
        } else {
          setAvatarEmployee(res[0].Resim);
          setopenPerakendeTV(true);
        }
      }).catch(error => {
        setopenPerakendeTV(false);
      });
  }, []);

  const SetApolloEmployeeNotification = (type) => {
    axios.get('/SetApolloEmployeeNotification/' + type)
  }

  const handleCloseCelebrationNotification = (type) => {
    if (type === 1) {
      setOpenBirthDayMessage(false);
    }
    else if (type === 2) {
      setopenWorkAnniversary(false);
    }
    else {
      setOpenCelebrationMessage(false);
    }
    SetApolloEmployeeNotification(type);
  }

  const getDialogWidth = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      return element.clientWidth;
    }
  }

  const getDialogHeight = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      return element.clientHeight;
    }
  }




  const PerakendeTVOpen = (event) => {
    event.persist();
    window.open("https://www.perakendetv.net/detail/F63131EE-B0F8-456A-8A90-FEF4D09ED9FF");
    event.persist();
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Tour
        steps={steps}
        isOpen={tour}
        onRequestClose={() => { setTourOpen(); setTour(false) }}
        accentColor='#FF9800'
        className="helper"
        rounded={20}
      />
      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent className={classes.content}>
          <WelcomeMessage title="Uyarılar" messages={SessionUser.Message?.split(String.fromCharCode(10))} />
        </CardContent>
        <Divider />
      </Card>
      <Dialog
        open={openBirthday}
        onClose={handleCloseBirthday}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <Typography variant="h6" component="h4">
            <br />
            Sevgili {SessionUser.NameSurname},
            <br />
            <br />
            Doğum gününü kutlar sevdiklerinle birlikte sağlık, mutluluk ve başarılarla dolu
            nice seneler dilerim.
            <br />
            <br />
            İyi ki doğdun!
            <br />
            <br />
            Sevgilerimle,
            <br />
            Hüseyin Şerif Beyaztaş
            <br />
            Arçelik Müşteri Hizmetleri Direktörü
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBirthday} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPerakendeTV}
        fullWidth
        maxWidth="lg"
        onClose={() => setopenPerakendeTV(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">Bilgilendirme</DialogTitle>
        <Divider />
        <DialogContent onClick={PerakendeTVOpen}>
          <StyledCardMedia
            component="img"
            alt="Banner"
            src={avatarEmployee}
          />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={() => setopenPerakendeTV(false)}
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openBirthDayMessage}
        onClose={() => handleCloseCelebrationNotification(1)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent id='birthDayDialog'>
          <Confetti
            width={getDialogWidth('birthDayDialog')}
            height={getDialogHeight('birthDayDialog')}
          />
          <div dangerouslySetInnerHTML={{ __html: birthDayMessage }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseCelebrationNotification(1)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openWorkAnniversary}
        onClose={() => handleCloseCelebrationNotification(2)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent id='workAnniversaryDialog'>
          <Confetti
            width={getDialogWidth('workAnniversaryDialog')}
            height={getDialogHeight('workAnniversaryDialog')}
          />
          <div dangerouslySetInnerHTML={{ __html: workAnniversaryMessage }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseCelebrationNotification(2)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCelebrationMessage}
        onClose={() => handleCloseCelebrationNotification(celebrationType)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth
      >
        <DialogContent id='celebrationDialog'>
          <Confetti
            width={getDialogWidth('celebrationDialog')}
            height={getDialogHeight('celebrationDialog')}
          />
          <div dangerouslySetInnerHTML={{ __html: celebrationMessage }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseCelebrationNotification(celebrationType)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>



    </div>
  );
}

Timeline.propTypes = {
  className: PropTypes.string
};

export default Timeline;
